'use client'

import { useEffect, useState } from 'react'

import { useCookieConsentContext } from '@graftcode/design-system'
import { GoogleTagManager } from '@next/third-parties/google'

import { GTM_CONSENT_SYNC_TEST_IDS } from '@common/common-test-ids.const'
import { getGtmConfig, pushGtmConsent } from '@common/utils/gtm'

export function GtmConsentSync() {
  const { consent, isInitialized } = useCookieConsentContext()
  const [hasMountedGtm, setHasMountedGtm] = useState(false)

  const { gtmId, auth: gtmAuth, preview: gtmPreview } = getGtmConfig()

  useEffect(() => {
    if (!isInitialized || !consent) return

    pushGtmConsent('update', consent)
  }, [consent, isInitialized])

  useEffect(() => {
    if (!gtmId || !isInitialized || !consent?.analytics) return

    setHasMountedGtm(true)
  }, [consent?.analytics, gtmId, isInitialized])

  if (!hasMountedGtm || !gtmId) {
    return null
  }

  return (
    <div data-testid={GTM_CONSENT_SYNC_TEST_IDS.root}>
      <GoogleTagManager gtmId={gtmId} auth={gtmAuth} preview={gtmPreview} />
    </div>
  )
}
